const logisticsRoutes = [
  {
    icon: "ri-ship-line",
    mode: "OCEAN FREIGHT",
    title: "FCL & LCL Consolidation",
    details: [
      "Guangzhou Port — South China Gateway",
      "Ningbo Port — East China Hub",
      "Full Container Load & Less-than-Container Load",
      "Worldwide port-to-port coverage",
    ],
  },
  {
    icon: "ri-truck-line",
    mode: "OVERLAND TRUCKING",
    title: "Road Freight Networks",
    details: [
      "Guangzhou — Central & Southeast Asia",
      "Hangzhou — Eastern China distribution",
      "Cross-border trucking to EAEU markets",
      "Door-to-door delivery capability",
    ],
  },
  {
    icon: "ri-train-line",
    mode: "RAIL FREIGHT",
    title: "China-Europe Railway Express",
    details: [
      "中欧班列 — China-Europe Railway Express",
      "Central Asia routes via Kazakhstan",
      "Russia & EAEU direct rail connections",
      "Faster than sea, cheaper than air",
    ],
  },
];

const trustBadges = [
  { icon: "ri-file-text-line", label: "Standard PO Processing" },
  { icon: "ri-eye-line", label: "Transparent Sourcing" },
  { icon: "ri-scales-line", label: "Legally Binding Contracts" },
  { icon: "ri-shield-check-line", label: "Customs Documentation" },
  { icon: "ri-time-line", label: "On-Time Delivery SLA" },
];

export default function FulfillmentSection() {
  return (
    <section id="fulfillment" className="relative overflow-hidden" style={{ background: "#0d1525" }}>
      {/* Hero visual — container ship */}
      <div className="relative h-[60vh] min-h-[420px] flex items-end">
        <img
          src="https://public.readdy.ai/ai/img_res/c10e6561663c92a8520b18b993c57bf2.jpg"
          alt="Global Ocean Freight"
          className="absolute inset-0 w-full h-full object-cover object-center"
        />
        <div
          className="absolute inset-0"
          style={{ background: "linear-gradient(to bottom, rgba(0,0,0,0.15) 0%, rgba(0,0,0,0.35) 55%, rgba(13,21,37,1) 100%)" }}
        />
        <div className="relative z-10 w-full max-w-6xl mx-auto px-6 pb-16">
          <p className="text-xs tracking-widest uppercase mb-4 font-medium" style={{ color: "#F59E0B", letterSpacing: "0.25em" }}>
            Global Fulfillment &amp; Compliance
          </p>
          <h2 className="text-4xl md:text-5xl font-thin text-white" style={{ letterSpacing: "0.04em" }}>
            HARDCORE GLOBAL
            <br />
            <span style={{ color: "#F59E0B" }}>LOGISTICS.</span>
          </h2>
        </div>
      </div>

      {/* Logistics Routes */}
      <div className="max-w-6xl mx-auto px-6 py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-16">
          {logisticsRoutes.map((route) => (
            <div
              key={route.mode}
              className="rounded-2xl p-8"
              style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)" }}
            >
              <div
                className="w-12 h-12 flex items-center justify-center rounded-xl mb-6"
                style={{ background: "rgba(245,158,11,0.12)", border: "1px solid rgba(245,158,11,0.3)" }}
              >
                <i className={`${route.icon} text-xl`} style={{ color: "#F59E0B" }} />
              </div>
              <p className="text-xs tracking-widest uppercase mb-2 font-medium" style={{ color: "#F59E0B", letterSpacing: "0.2em" }}>
                {route.mode}
              </p>
              <h3 className="text-lg font-bold mb-5 text-white" style={{ letterSpacing: "0.04em" }}>
                {route.title}
              </h3>
              <div className="mb-5" style={{ width: "36px", height: "1.5px", background: "#F59E0B" }} />
              <ul className="flex flex-col gap-3">
                {route.details.map((detail) => (
                  <li key={detail} className="flex items-start gap-3">
                    <div className="w-1.5 h-1.5 rounded-full mt-1.5 shrink-0" style={{ background: "#F59E0B" }} />
                    <span className="text-sm font-light" style={{ color: "rgba(255,255,255,0.6)", lineHeight: "1.6" }}>
                      {detail}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* China-Europe Rail visual */}
        <div className="relative rounded-2xl overflow-hidden mb-16" style={{ height: "320px" }}>
          <img
            src="https://readdy.ai/api/search-image?query=dramatic%20photograph%20of%20China%20Europe%20freight%20train%20on%20railway%20tracks%20crossing%20vast%20Central%20Asian%20steppe%20landscape%20at%20dusk%20with%20dramatic%20sky%20and%20mountains%20in%20background%20China%20Europe%20Railway%20Express%20%E4%B8%AD%E6%AC%A7%E7%8F%AD%E5%88%97%20cargo%20train%20ultra%20high%20resolution%20cinematic%20photography&width=1400&height=500&seq=logistics-rail-v2-01&orientation=landscape"
            alt="China-Europe Railway Express"
            className="w-full h-full object-cover object-center"
          />
          <div
            className="absolute inset-0"
            style={{ background: "linear-gradient(to right, rgba(15,20,35,0.88) 0%, rgba(15,20,35,0.45) 55%, rgba(15,20,35,0.1) 100%)" }}
          />
          <div className="absolute inset-0 flex items-center px-10 md:px-16">
            <div className="max-w-lg">
              <p className="text-xs tracking-widest uppercase mb-3 font-medium" style={{ color: "#F59E0B", letterSpacing: "0.2em" }}>
                Rail Freight Highlight
              </p>
              <h3 className="text-2xl md:text-3xl font-thin text-white mb-4" style={{ letterSpacing: "0.04em" }}>
                CHINA-EUROPE RAILWAY EXPRESS
              </h3>
              <p className="text-sm font-light mb-2 text-white/75" style={{ lineHeight: "1.8" }}>
                中欧班列 — Direct rail connections from China to Russia, Central Asia, and Europe.
                Faster than sea freight, significantly more cost-effective than air.
              </p>
              <p className="text-xs text-white/40">
                Routes: Guangzhou → Almaty → Moscow · Hangzhou → Tashkent · Ningbo → Warsaw
              </p>
            </div>
          </div>
        </div>

        {/* Trust Badges */}
        <div
          className="rounded-2xl p-8"
          style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)" }}
        >
          <p className="text-xs tracking-widest uppercase mb-6 text-center font-medium" style={{ color: "rgba(255,255,255,0.35)", letterSpacing: "0.2em" }}>
            Compliance &amp; Trade Standards
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            {trustBadges.map((badge) => (
              <div
                key={badge.label}
                className="flex items-center gap-3 px-5 py-3 rounded-xl"
                style={{ background: "rgba(245,158,11,0.08)", border: "1px solid rgba(245,158,11,0.2)" }}
              >
                <div className="w-5 h-5 flex items-center justify-center shrink-0">
                  <i className={`${badge.icon} text-sm`} style={{ color: "#F59E0B" }} />
                </div>
                <span className="text-xs font-semibold tracking-widest whitespace-nowrap text-white" style={{ letterSpacing: "0.08em" }}>
                  {badge.label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
